import { LIST } from '../../graphql/Query/admins';
import { DISABLE } from '../../graphql/Mutation/admins';
import { useMutation, useQuery } from '@apollo/client';
import CustomTable from '@myComponents/CustomTable';

import { handleConfirmCancel, handleError } from '@components/toast';
import { columns } from './columns';

import { useState } from 'react';
import Sidebar from './Sidebar';

const variables = {
  search: {
    q: '',
    page: 1,
    perPage: 10,
    status: 'EMPTY',
    permissions: 'EMPTY'
  }
};
const defaultValues = {
  fullName: '',
  email: '',
  phone: '',
  phonecode: '+57',
  password: '',
  permissions: [],
  status: 'ACTIVE'
};

const AdminsList = () => {
  const { loading, data, refetch } = useQuery(LIST, {
    variables
  });
  const [handleDisable] = useMutation(DISABLE);
  const [valuesForm, setValuesForm] = useState({});
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const handleUpdate = ({ e, row }) => {
    e.preventDefault();
    setValuesForm({
      ...row,
      phone: row?.phone
        ? row.phone.substring(row.phonecode.length, row.phone.length)
        : '',
      password: ''
    });
    toggleSidebar();
  };

  const handleDelete = async ({ e, row }) => {
    e.preventDefault();
    const type = row.status === 'ACTIVE' ? 'inactive' : 'active';
    handleConfirmCancel(type, false, async () => {
      try {
        await handleDisable({ variables: { id: row._id } });
        refetch();
      } catch (e) {
        handleError(e);
        throw e;
      }
    });
  };

  return (
    <CustomTable
      loading={loading}
      store={data?.listAdmin?.docs || []}
      data={{ ...data?.listAdmin, docs: undefined }}
      refetch={refetch}
      headerOptions={{
        type: 'add',
        name: 'Crear Admin',
        handle: () => {
          setValuesForm(defaultValues);
          toggleSidebar();
        }
      }}
      filterOptions={{
        types: [
          {
            id: 'admin_permissions',
            name: 'permissions',
            options: 'permissionsOptions',
            type: 'select'
          },
          {
            id: 'admin_status',
            name: 'status',
            options: 'statusOptions',
            type: 'select'
          }
        ]
      }}
      variables={variables}
      columns={columns({ handleUpdate, handleDelete })}
      sidebar={
        <Sidebar
          open={sidebarOpen}
          toggleSidebar={toggleSidebar}
          defaultValues={valuesForm}
          handleFetching={refetch}
        />
      }
    />
  );
};

export default AdminsList;
